// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';

/**
 * 基础菜单
 */
// 系统首页
import baseIndex from '@/views/base/index';
// 个人中心  userindex
import uindex from '@/views/user/index';
//修改密码
import upassedit from '@/views/user/upassedit';
// 资料修改  updateuser
import updateuser from '@/views/user/updateuser';
//任务详情
import rwxq from '@/views/user/rwxq';
// 任务介绍 cpjs
import cpjs from '@/views/user/cpjs';
import cpjsa from '@/views/user/cpjsa';
import cpjsa1 from '@/views/user/cpjsa1';
//答题
import dt from '@/views/user/dati';
import dta from '@/views/user/datia';
import dta1 from '@/views/user/datia1';
//客服
import kf from '@/views/user/kefu';
//咨询
import zixuna from '@/views/user/zixun';
//测评任务
import cprw from '@/views/user/cprw';
//我的测评
import wdcp from '@/views/user/wdcp';
//我的测评详情
import wdcpxq from '@/views/user/wdcpdetail';

import wdcpxq1 from '@/views/user/wdcpdetail1';
import wdcpxq2 from '@/views/user/wdcpdetail2';
//咨询详情
import zixundetail from '@/views/user/zixundetail';


/**
 * 随访管理
 */


/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 角色管理
import Role from '@/views/system/Role';
// 权限管理
import Permission from '@/views/system/Permission';
// 日志管理
import log from '@/views/system/log';

//填报
/* import tb from '@/views/dcgl/tb'; */
//添加随访计划
/* import addkhsf from '@/views/sfgl/addkhsf'; */
// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    mode:'history',
    routes: [{
        path: '/',
        name: '',
        component: baseIndex,
        hidden: true,
        meta: {
            requireAuth: true
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/base/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/base/index',
            name: '系统首页',
            component: baseIndex,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/index',
            name: '个人中心',
            component: uindex,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/upassedit',
            name: '密码修改',
            component: upassedit,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/updateuser',
            name: '资料修改',
            component: updateuser,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/rwxq/:id',
            name: '任务详情',
            component: rwxq,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/cpjs/:id',
            name: '测评介绍',
            component: cpjs,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/cpjsa/:id',
            name: '测评介绍',
            component: cpjsa,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/cpjsa1/:id',
            name: '测评介绍',
            component: cpjsa1,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/dati/:id',
            name: '答题',
            component: dt,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/datia/:id',
            name: '答题',
            component: dta,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/datia1/:id',
            name: '答题',
            component: dta1,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/kefu',
            name: '在线客服',
            component: kf,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/zixun',
            name: '在线咨询',
            component: zixuna,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/cprw',
            name: '测评任务',
            component: cprw,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/wdcp',
            name: '我的测评',
            component: wdcp,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/wdcpdetail/:id/:rwid/:title',
            name: '我的测评详情',
            component: wdcpxq,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/wdcpdetail1/:id/:rwid/:title',
            name: '我的测评详情',
            component: wdcpxq1,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/wdcpdetail2/:id/:rwid/:title',
            name: '我的测评详情',
            component: wdcpxq2,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/log',
            name: '日志管理',
            component: log,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/user/zixundetail',
            name: '咨询详情',
            component: zixundetail,
            meta: {
                requireAuth: true
            }
        }

        ]
    }]
})




// WEBPACK FOOTER //
// ./src/router/index.js